module.exports = __webpack_public_path__ + "img/KinokoTable12.2b26bb6c.jpg";